// extracted by mini-css-extract-plugin
export default {"color-white":"#FFFFFF","colorWhite":"#FFFFFF","color-black":"#000000","colorBlack":"#000000","buttonMultiply":"_1TYxF","buttonBuyNow":"_2c3wZ"};